import React, { useEffect } from "react";
import { GeneralModal } from "../GeneralComponents/GeneralModal";
import moment from "moment";
import { GeneralTable } from "../GeneralComponents/GeneralTable";
import { PopoverButton } from "../GeneralComponents";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  centeredCell: {
    display: "flex",
    alignItems: "center",
    whiteSpace: "pre-wrap",
    overflow: "hidden", // Hides overflow if it's on one line
    textOverflow: "ellipsis", // Adds '...' if the text is truncated
    lineHeight: "normal", // Ensure standard line height
  },
});

export function DocumentaryViewTRD({
  row,
  openModal,
  handleCloseModal,
  consultarRegistro,
}) {
  const classes = useStyles();
  const [isView, setIsView] = React.useState(true);
  const [listSede, setSede] = React.useState([]);
  const [listUnidadAdministrativa, setUnidadAdministrativa] = React.useState(
    [],
  );
  const [listTRDcargadas, setListTRDcargadas] = React.useState([]);

  const [formData, setFormData] = React.useState({
    codigo: row.codigo,
    descripcion: row.descripcion,
    fecha_creacion: moment(),
    id_sede: row.id_sede,
    id_gd_dependencia: row.id_gd_dependencia,
    id_unidad_administrativa: row.id_unidad_administrativa,
  });

  useEffect(() => {
    loadSedes();
    loadUnidadAdministrativa();
    loadTRD();
  }, []);

  const loadTRD = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `dependencia-trd/listar?id_gd_dependencia=${row.id_gd_dependencia}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setListTRDcargadas(data);
      });
  };

  const newModalField = [
    {
      name: "fecha_creacion",
      label: "Fecha de Creación",
      type: "date",
    },
    { name: "codigo", label: "Código", type: "text" },
    {
      name: "descripcion",
      label: "Nombre de la dependencia/productora",
      type: "text",
    },
    {
      name: "id_unidad_administrativa",
      label: "Unidad Administrativa",
      type: "select",
      options: listUnidadAdministrativa,
    },
    {
      name: "id_sede",
      label: "Sede",
      type: "select",
      options: listSede,
    },
  ];

  const loadSedes = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "sedes/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listasede = data.map((sede) => {
          return { value: sede.id_sede, label: sede.nombre };
        });
        setSede(listasede);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadUnidadAdministrativa = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "unidad-administrativa/listar",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaUnidad = data.map((unidad) => {
          return {
            value: unidad.id_unidad_administrativa,
            label: unidad.nombre,
          };
        });
        setUnidadAdministrativa(listaUnidad);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const columns = [
    {
      field: "descripcion_serie",
      headerName: "SERIE",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "descripcion_subserie",
      headerName: "SUBSERIE",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "descripcion_tipo_documental",
      headerName: "TIPO DOCUMENTAL",
      flex: 2,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    /* {
      field: "tipos_documentales",
      headerName: "TIPOS DOCUMENTALES",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
      align: "center",
      renderCell: (params) => {
        return (
          <PopoverButton
            content={
              <div style={{ whiteSpace: "pre-wrap", padding: "1px" }}>
                {params.value.map((tp) => `* ${tp.descripcion}`).join("\n")}
              </div>
            }
            buttonText={"ver más"}
          />
        );
      },
    }, */
  ];

  return (
    <>
      <GeneralModal
        open={openModal}
        titleAlert={"TRD"}
        onClose={handleCloseModal}
        fields={newModalField}
        formData={formData}
        onFieldChange={handleFieldChange}
        setFormData={setFormData}
        initialFormData={{
          serie_id: "",
          subserie_id: "",
          documentTypes: [],
        }}
        enableDocumentarytype={true}
        isView={isView}
        setIsView={setIsView}
        title={"Información detallada de TRD"}
        width={"42%"}
        height={"98%"}
        consultarRegistro={consultarRegistro}
      >
        <GeneralTable
          title=""
          columns={columns}
          rows={listTRDcargadas}
          enableActions={false}
          isDocumentaryView={true}
        />
      </GeneralModal>
    </>
  );
}
